module.exports = __webpack_public_path__ + "img/ZEC.d9364259.svg";